import { AppBar, Box, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
// import TodayRecords from "./TodayRecords";
import RenderCurationHistory from './RenderCurationHistory';
import History from './History';
const HistoryTab=()=>{
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
    };
    useEffect(() => {
      // Scroll to the top of the page on component mount
      window.scrollTo(0, 0);
    }, []); // Empty dependency array to only run on component mount
   return(
    <div  style={{padding:"0"}}>
       <Box  sx={{marginX:'1%',marginTop:"0rem",padding:"0px",}}>
        <Tabs value={activeTab} onChange={handleTabChange} 
         textColor="inherit" // Use "inherit" here to allow custom styling
         indicatorColor="primary" // Use "primary" here; we'll customize it using sx
         sx={{
          position:"sticky",top:"3.75rem",zIndex:"10",background:"#fff",marginTop:"-0.2rem",padding:"10px",borderRadius:"12px",
           '& .MuiTab-root': {
             color: '#000', // Default color for all tabs
           },
           '& .Mui-selected': {
             color: '#0576FC', // Custom color for the active tab
           },
           '& .MuiTabs-indicator': {
             backgroundColor: '#0576FC', // Custom color for the indicator
           },
         }}>
          <Tab label="Data File Status" />
          <Tab label="Curation Status" />
        </Tabs>
        {activeTab === 0 && (
          <Box >
            <History activeTab={activeTab} />
          </Box>
        )}
        {activeTab === 1 && (
          <Box >
            <RenderCurationHistory activeTab={activeTab}/>
          </Box>
        )}
      </Box>
    </div>
   ) 
}
export default HistoryTab